export default "__VITE_ASSET__4YYZ9sdI__"